<template>
  <div class="d-flex align-items-center min-vh-100 bg">
    <b-container>
      <div v-if="isLoading">
        <OtherLoading />
      </div>
      <b-row class="justify-content-center" v-else>
        <b-col md="9" lg="6" class="login">
          <b-card-group>
            <b-card class="p-4 shadow-lg">
              <b-card-body class="login-box">
                <b-form>
                  <div class="text-center img-logo-cover">
                    <div
                      class="imgLogo"
                      v-bind:style="{
                        'background-image':
                          'url(' + $store.state.logoHomePage + ')',
                      }"
                    ></div>
                    <hr class="my-4" />
                  </div>
                  <InputText
                    class="my-3 login-input"
                    v-model="form.Email"
                    textFloat="Email"
                    placeholder="ชื่อผู้ใช้งาน"
                    type="email"
                    name="email"
                    isRequired
                    :isValidate="$v.form.Email.$error"
                    :v="$v.form.Email"
                    @onKeyup="submitFormOnInput"
                  />
                  <InputText
                    class="my-3 login-input"
                    v-model="form.Password"
                    textFloat="Password"
                    placeholder="รหัสผ่าน"
                    type="password"
                    name="password"
                    isRequired
                    :isValidate="$v.form.Password.$error"
                    :v="$v.form.Password"
                    @onKeyup="submitFormOnInput"
                    isShowPassword
                  />
                  <b-row v-if="error != ''" class="m-2 text-center">
                    <span class="text-danger w-100">
                      {{ error }}
                      <br />
                      {{ " " }}
                    </span>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button
                        type="button"
                        class="px-4 login-btn"
                        :style="`background-color: ${theme.colorSecondary};border: 1px solid ${theme.colorSecondary}`"
                        @click="checkForm"
                        :disabled="isDisable"
                        >เข้าสู่ระบบ
                        <b-spinner
                          class="align-middle"
                          v-if="isLogin"
                        ></b-spinner
                      ></b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import InputText from "@/components/inputs/InputText";
import imgLogo from "@/assets/images/icons/logo.svg";
import OtherLoading from "@/components/loading/OtherLoading";
export default {
  name: "Login",
  components: {
    InputText,
    OtherLoading,
  },
  data() {
    return {
      imgLogo: imgLogo,
      error: "",
      form: {
        Email: "",
        Password: "",
      },
      theme: {
        logo: "",
        colorPrimary: "",
        colorSecondary: "",
      },
      isLoading: false,
      isDisable: false,
      isLogin: false,
      passwordType: "",
    };
  },
  validations() {
    return {
      form: {
        Email: { required, email },
        Password: { required },
      },
    };
  },
  mounted: async function () {},
  created() {
    this.$cookies.remove("token");
    // this.getTheme();
  },
  methods: {
    checkForm: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;
      this.isDisable = true;
      this.isLogin = true;
      this.error = "";
      // this.axios.post(`https://api-dev-brandadmin.dosetech.co/api/login`, this.form).then((data) => {
      this.axios
        .post(`${this.$baseUrl}/customer/login`, this.form)
        .then(async (data) => {
          this.isDisable = false;
          if (data.result == 1) {
            var timestamp = new Date().getTime();
            this.$cookies.set("crm-timestamp", timestamp);
            this.$store.dispatch("setTimestamp", timestamp);

            await this.$cookies.set("token", data.detail.token);
            // await this.$cookies.set("tnl-username", data.detail.account_name);
            await this.$cookies.set("branch_id", data.detail.branch_id);
            await this.$cookies.set("name", data.detail.name);
            await this.$cookies.set("user_guid", data.detail.user_guid);
            // // await this.$cookies.set("invoice_length", data.detail.invoice_length);
            // await this.$cookies.set("plant_id", data.detail.plant_id);
            // await this.$cookies.set("booth", data.detail.booth);
            // await this.$cookies.set("spa", data.detail.spa);
            this.$store.dispatch("setSlideBarCurrent", 1);

            this.isLoading = false;
            this.isDisable = false;
            this.isLogin = false;

            window.location.href = "/employee/info";
          } else {
            this.isLoading = false;
            this.isLogin = false;
            this.error = data.message;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    submitFormOnInput: function (e) {
      if (e.keyCode === 13) {
        this.checkForm();
      }
    },
    handleShowHidePassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
    getTheme() {
      this.isLoading = true;
      this.axios.get(`${this.$baseUrl}/customer/theme`).then((data) => {
        // this.theme = {
        //   logo: data.themeLogoHomePage,
        //   colorPrimary: data.themePrimaryColor,
        //   colorSecondary: data.themeSecondaryColor,
        // };
        this.theme = {
          logo: "Upload/blue_label.png",
          colorPrimary: "#021140",
          colorSecondary: "#e0be5d",
        };
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
.bg {
  background-color: var(--primary-color);
}
</style>
